import { Navigate, NavLink, Outlet, Link } from "react-router-dom";
import { LogOut, GraduationCap, Users, ClipboardList, KeyRound } from "lucide-react";
import { useAuth } from "@/lib/auth";

const links = [
  { to: "/admin", label: "Enquiries", icon: ClipboardList, end: true },
  { to: "/admin/students", label: "Students", icon: Users },
  { to: "/admin/codes", label: "Enrollment Codes", icon: KeyRound },
];

export default function AdminLayout() {
  const { user, ready, logout } = useAuth();

  if (!ready) return <div className="p-10 text-slate-500">Loading…</div>;
  if (!user || user.role !== "admin") return <Navigate to="/admin/login" replace />;

  return (
    <div className="min-h-screen bg-[#F5F7FA]">
      <div className="grid lg:grid-cols-[240px_1fr] min-h-screen">
        <aside className="bg-[#0B192C] text-white relative overflow-hidden lg:min-h-screen">
          <div className="vk-grain" />
          <div className="relative p-6 h-full flex flex-col">
            <Link to="/" className="flex items-center gap-2 mb-8">
              <span className="w-9 h-9 rounded-md bg-white/5 border border-white/10 grid place-items-center">
                <GraduationCap size={20} className="text-[#FF6B35]" />
              </span>
              <div>
                <div className="font-display font-bold uppercase tracking-tight">Vikramshila</div>
                <div className="text-[10px] uppercase tracking-widest text-[#FF6B35] font-semibold">Classes · Admin</div>
              </div>
            </Link>
            <nav className="space-y-1">
              {links.map(({ to, label, icon: Icon, end }) => (
                <NavLink
                  key={to} to={to} end={end}
                  data-testid={`nav-admin-${label.toLowerCase().replace(/\s+/g, "-")}`}
                  className={({ isActive }) =>
                    `flex items-center gap-3 px-3 py-2 rounded-md text-sm font-medium transition-colors ${
                      isActive ? "bg-white/10 text-white border border-white/10" : "text-white/70 hover:bg-white/5 hover:text-white"
                    }`
                  }
                >
                  <Icon size={16} /> {label}
                </NavLink>
              ))}
            </nav>
            <div className="mt-auto pt-8 space-y-3 text-sm">
              <div className="text-white/60 text-xs uppercase tracking-widest">Signed in</div>
              <div className="text-white font-medium break-all">{user.email}</div>
              <button onClick={logout} data-testid="admin-logout" className="vk-btn-outline w-full justify-center text-sm">
                <LogOut size={14} /> Log out
              </button>
            </div>
          </div>
        </aside>

        <main className="p-6 lg:p-10 space-y-8">
          <Outlet />
        </main>
      </div>
    </div>
  );
}
